module.exports = __webpack_public_path__ + "images/Pool-12762c7e83c77135867ed27f78cd6b38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Pool.jpg
// module id = 22
// module chunks = 0